import React, { useEffect, useState } from "react";
import { Button, Badge } from "reactstrap";
import NotificationModal from "./NotificationModal";
import { FaBell } from "react-icons/fa";
import { useSelector } from "react-redux";
import createJobSelector from "store/job/selector";
import axios from "axios";
import ability from "config/ability";

const Notification = () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const { id, role } = userData;
    const jobSelector = useSelector(createJobSelector);
    const { AllNotifications } = jobSelector;
    const [notifications, setNotifications] = useState([]);

    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleReadNotification = async () => {
        toggleModal();
      await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/job/notifications-read`
      );
  };

    useEffect(() => {
      const filterNotification = AllNotifications.filter((notif) => {
          if (notif.receiver === id) {
              return notif.status === "Completed";
          }

        if (!ability.can("read", "Technician") && notif.receiver === "Admin") {
            return notif.status === "Completed";
        }

        return false;
    });

      setNotifications(filterNotification);
  }, [AllNotifications, id, ability]);

    return (
        <div>
          <div
              className="ms-5"
              style={{ position: "relative", color: "white", cursor: "pointer" }}
              onClick={handleReadNotification}
          >
              <FaBell size={30} />
              {notifications.length > 0 && (
                  <Badge
                      color="danger"
                      style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          borderRadius: "50%",
                          padding: "3px",
                          fontSize: "12px",
                      }}
                  >
                      {notifications.length}
                  </Badge>
              )}
          </div>

          {modalOpen && (
              <NotificationModal
                  notifications={notifications}
                  toggle={toggleModal}
                  recieverId={role === "Owner" ? "Admin" : id}
              />
          )}
      </div>
  );
};

export default Notification;
